import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Vantaihanghoathongthuong from "components/Vantaihanghoa/Vantaihanghoathongthuong.js";
export default function BCVantaitt() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo tháng vận tải hàng hóa thông thường",
            tabContent: <Vantaihanghoathongthuong />,
          },
        ]}
      />
    </div>
  );
}
